"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDrink = function SvgDrink(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.758 4.583a.29.29 0 0 0 .284-.272 3.402 3.402 0 0 1 3.397-3.12 3.41 3.41 0 0 1 3.397 3.12.29.29 0 0 0 .284.272h1.394c.334 0 .594.29.563.622-.177 1.814-1.157 7.063-6.732 8.214-.56.064-.906.24-.906.65v3.997a.57.57 0 0 0 .445.53l5.123 1.287a.857.857 0 0 1-.21 1.687H5.358a.857.857 0 0 1-.21-1.687l5.052-1.295a.571.571 0 0 0 .412-.506v-3.99c0-.335-.335-.6-.668-.635a2.298 2.298 0 0 1-.238-.038c-5.575-1.151-6.555-6.4-6.732-8.214a.568.568 0 0 1 .563-.622h8.221Zm5.025 0a.287.287 0 0 0 .273-.287c0-.777-.919-1.352-1.607-1.352s-1.617.573-1.617 1.352a.286.286 0 0 0 .284.287h2.667ZM8.126 9.468a.57.57 0 0 0-.386.977c1 .854 2.469 1.47 4.291 1.47 1.823 0 3.287-.614 4.287-1.466a.57.57 0 0 0-.382-.981H8.127Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDrink);
var _default = exports["default"] = Memo;